import React from "react";
import PropTypes from "prop-types";
import { ChevronRight } from "react-feather";

const NavigationItem = ({ icon, title, onClick }) => {
    const MenuIcon = icon;
    return (
        <div className="navigation-item" onClick={onClick}>
            <div className="navigation-left">
                <MenuIcon size={24} className="navigation-icon" />
                <span className="navigation-title">{title}</span>
            </div>
            <ChevronRight size={24} />
        </div>
    );
};

NavigationItem.propTypes = {
    icon: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default NavigationItem;
